export const TEXT_FIELD = 'text_field'
export const MONEY_FIELD = 'money_field'
export const DATE_FIELD = 'date_field'
export const EXPAND_FIELD = 'expand_field'
export const BUTTON_A_FIELD = 'button_a_field'
export const BUTTON_G_FIELD = 'button_g_field'
export const LIST_FIELD = 'list_field'
export const BUTTON_S_FIELD = 'button_s_field'
export const TEAM_FIELD = 'team_field'
export const COMPANY_FIELD = 'company_field'
export const CUSTOMER_FIELD = 'customer_field'